(() => {
  if(window.ffnLanguagePickerInitialized)return;
  window.ffnLanguagePickerInitialized=true;
  document.addEventListener('click', event => {
    document.querySelectorAll('.ffn-language-picker[open]').forEach(picker => {
      if(!picker.contains(event.target))picker.open=false;
    });
  });
  document.addEventListener('keydown', event => {
    if(event.key!=='Escape')return;
    const picker=event.target.closest('.ffn-language-picker[open]');
    if(picker){picker.open=false;picker.querySelector('summary').focus();}
  });
})();
